import type { ReactElement } from 'react';
import { SessionExpiredPage, getSessionExpiryKindFromLocationState } from '@hsus-dev/session-policy';
import type { SessionExpiredPageProps } from '@hsus-dev/session-policy';
import { useLocation } from 'react-router-dom';

type Props = Omit<SessionExpiredPageProps, 'expiryKind'>;

/**
 * Reads React Router location state when present (idle session expiry navigation from `App`).
 */
export function SessionExpiredRoute(props: Props): ReactElement {
  const { state } = useLocation();
  return <SessionExpiredPage {...props} expiryKind={getSessionExpiryKindFromLocationState(state)} />;
}
